import React from 'react';
import EditStudFees from "./EditStudentFees";
import '../../../CommonCSS/SocietyCSS.css'

const EditStudFeesApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5> Edit Fees Receipt/Structure </h5>
          </div>  
        </div>
        <EditStudFees/>
      </div>
    </div >
  );
};

export default EditStudFeesApp;
